<div class="container">
  <div class="modal-header mb-4">
    <h5 *ngIf="!data">{{ 'map.sidebar.psa.risk_event.title_new' | translate }}</h5>
    <h5 *ngIf="!!data">{{ 'map.sidebar.psa.risk_event.title_edit' | translate }} - {{ data?.nome }}</h5>
  </div>

  <div class="modal-body">
    <div class="container scrollable-container">
      <form [formGroup]="riskEventForm" (ngSubmit)="onSave()">
        <div class="row pt-1">
          <div class="col-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.risk_event.name_label' | translate }}</mat-label>
              <textarea
                matInput
                formControlName="nome"
                placeholder="{{ 'map.sidebar.psa.risk_event.name_label' | translate }}"
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="10"
              ></textarea>
            </mat-form-field>
          </div>
          <div class="col-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.risk_event.description_label' | translate }}</mat-label>
              <textarea
                matInput
                formControlName="descrizione"
                placeholder="{{ 'map.sidebar.psa.risk_event.description_label' | translate }}"
                cdkTextareaAutosize
                cdkAutosizeMinRows="3"
                cdkAutosizeMaxRows="10"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <mat-checkbox formControlName="pericolo_chimico">{{ 'map.sidebar.psa.risk_event.pericolo_chimico' | translate }}</mat-checkbox>
          </div>
          <div class="col-6">
            <mat-checkbox formControlName="pericolo_fisico">{{ 'map.sidebar.psa.risk_event.pericolo_fisico' | translate }}</mat-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <mat-checkbox formControlName="pericolo_biologico">{{ 'map.sidebar.psa.risk_event.pericolo_biologico' | translate }}</mat-checkbox>
          </div>
          <div class="col-6">
            <mat-checkbox formControlName="pericolo_quantitativo">{{ 'map.sidebar.psa.risk_event.pericolo_quantitativo' | translate }}</mat-checkbox>
          </div>
        </div>

        <hr />

        <mat-accordion multi="true">
          <mat-expansion-panel *ngFor="let riga of righe" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ riga.tipologia || ('map.sidebar.psa.risk_event.type_label' | translate) }}
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="row align-items-center">
              <div class="col-11">
                <mat-form-field class="w-100" appearance="outline">
                  <mat-label>{{ 'map.sidebar.psa.risk_event.type_label' | translate }}</mat-label>
                  <mat-select
                    [(ngModel)]="riga.tipologia"
                    [ngModelOptions]="{ standalone: true }"
                    [disabled]="riga.associatedEntities.length > 0"
                    (selectionChange)="onTipologiaChange(riga)"
                    required
                  >
                    <mat-option *ngFor="let option of tipologieDisponibili(riga)" [value]="option.tipologia">{{ option.tipologia }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-1 d-flex justify-content-end">
                <button
                  type="button"
                  mat-icon-button
                  color="warn"
                  (click)="rimuoviRiga(riga)"
                  matTooltip="{{ 'map.sidebar.psa.risk_event.remove_tipologia_tooltip' | translate }}"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-4 d-flex align-items-center gap-2">
                {{ 'map.sidebar.psa.risk_event.gravita' | translate }} * :
                <app-rank-selector [valueRank]="riga.gravita" [allowEmpty]="true" (rankChange)="riga.gravita = $event"></app-rank-selector>
              </div>

              <div class="col-8">
                <mat-checkbox
                  [(ngModel)]="riga.assignAll"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="!riga.tipologia || riga.caricamentoTutti"
                  (ngModelChange)="onAssegnaATuttiChange(riga, $event)"
                >
                  {{ 'map.sidebar.psa.risk_event.assign_all_label' | translate }}
                </mat-checkbox>
                <small class="d-block ms-4" *ngIf="riga.assignAll && riga.totaleTipologia !== null">
                  {{
                    riga.totaleTipologia
                      ? ('map.sidebar.psa.risk_event.assign_all_count' | translate : { count: riga.totaleTipologia })
                      : ('map.sidebar.psa.risk_event.assign_all_none' | translate : { tipologia: riga.tipologia })
                  }}
                </small>
              </div>
            </div>

            <!-- ricerca elementi di rete da associare, nascosta se 'assegna a tutti' e' flaggato -->
            <div class="row mt-3" *ngIf="!riga.assignAll && riga.tipologia">
              <div class="col-12">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{ 'map.sidebar.psa.risk_event.search_label' | translate }}</mat-label>
                  <input
                    type="text"
                    placeholder="{{ 'map.sidebar.psa.risk_event.search_placeholder' | translate }}"
                    matInput
                    (input)="onInput(riga)"
                    (keydown.enter)="$event.preventDefault()"
                    [(ngModel)]="riga.inputValue"
                    [ngModelOptions]="{ standalone: true }"
                    [matAutocomplete]="auto"
                  />
                  <mat-autocomplete
                    autoActiveFirstOption
                    #auto="matAutocomplete"
                    [displayWith]="nessunTesto"
                    (optionSelected)="onOptionSelected(riga, $event.option.value)"
                  >
                    <mat-option *ngFor="let option of elementiSelezionabili(riga)" [value]="option">
                      {{ option.search_term }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>

            <!-- elementi associati e relativa ricerca solo se ce n'e' almeno uno -->
            <div class="row mt-3" *ngIf="riga.tipologia && riga.associatedEntities.length > 0">
              <div class="col-12">
                <span class="d-block mb-2">{{ 'map.sidebar.psa.risk_event.associated_elements_label' | translate }}</span>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label class="mb-2">{{ 'map.sidebar.psa.risk_event.search_placeholder_associated_event' | translate }}</mat-label>
                  <input
                    type="text"
                    placeholder="{{ 'map.sidebar.psa.risk_event.search_placeholder_associated_event' | translate }}"
                    matInput
                    [ngModelOptions]="{ standalone: true }"
                    (input)="onInputFilter(riga)"
                    (keydown.enter)="$event.preventDefault()"
                    [(ngModel)]="riga.filterValue"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="scrollable-div" *ngIf="riga.tipologia && riga.associatedEntities.length > 0">
              <mat-list>
                <mat-list-item *ngFor="let element of riga.associatedEntitiesFiltered">
                  <div class="d-flex align-items-center justify-content-between gap-3">
                    <div class="right d-flex align-items-center justify-content-start gap-2">
                      <button
                        type="button"
                        mat-icon-button
                        color="warn"
                        (click)="removeEntitiy(riga, element)"
                        matTooltip="{{ 'map.sidebar.psa.risk_event.delete_tooltip' | translate }}"
                      >
                        <mat-icon>delete</mat-icon>
                      </button>
                      <div class="d-flex flex-column align-items-start" [title]="element?.schema_idropotabile?.search_term">
                        <span>{{ element?.schema_idropotabile?.search_term }}</span>
                        <small style="margin-top: -0.25rem">{{ element?.schema_idropotabile?.type | translate }}</small>
                      </div>
                    </div>
                    <div class="left d-flex justify-content-end align-items-center gap-2">
                      <span>{{ 'map.sidebar.psa.risk_event.probability' | translate }} :</span>
                      <app-rank-selector
                        [valueRank]="element.probabilita"
                        [allowEmpty]="true"
                        (rankChange)="element.probabilita = $event"
                      ></app-rank-selector>
                    </div>
                  </div>
                </mat-list-item>
              </mat-list>
            </div>
          </mat-expansion-panel>
        </mat-accordion>

        <div class="d-flex justify-content-center py-3">
          <button
            type="button"
            mat-mini-fab
            color="primary"
            [disabled]="!puoAggiungereRiga"
            (click)="aggiungiRiga()"
            matTooltip="{{ 'map.sidebar.psa.risk_event.add_tipologia_tooltip' | translate }}"
          >
            <mat-icon>add</mat-icon>
          </button>
        </div>
      </form>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 align-items-end mt-4">
    <button mat-button type="button" (click)="onCancel()">
      {{ 'map.sidebar.psa.risk_event.button_cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" type="submit" (click)="onSave()" [disabled]="!formValido">
      {{ 'map.sidebar.psa.risk_event.button_save' | translate }}
    </button>
  </div>
</div>
